export const DEFAULT_ASAAS_ACCOUNT_LABELS = {
    default: "Padrão",
    secondary: "Secundária",
    tertiary: "Terciária",
} as const;

export type AsaasAccountKey = keyof typeof DEFAULT_ASAAS_ACCOUNT_LABELS;

export type AsaasAccountLabels = Partial<
    Record<AsaasAccountKey, string | null>
>;

export function getAsaasAccountLabel(
    account: AsaasAccountKey,
    labels?: AsaasAccountLabels | null
): string {
    const customName = labels?.[account]?.trim();

    return customName || DEFAULT_ASAAS_ACCOUNT_LABELS[account];
}

export function isAsaasAccountKey(
    value: string | null | undefined
): value is AsaasAccountKey {
    return value != null && value in DEFAULT_ASAAS_ACCOUNT_LABELS;
}

export type AsaasAccountOption = {
    account: AsaasAccountKey;
    label: string;
    active: boolean;
};

export const FALLBACK_ASAAS_ACCOUNTS: AsaasAccountOption[] = (
    Object.keys(DEFAULT_ASAAS_ACCOUNT_LABELS) as AsaasAccountKey[]
).map((account) => ({
    account,
    label: DEFAULT_ASAAS_ACCOUNT_LABELS[account],
    active: true,
}));

export function getSelectableAsaasAccounts(
    accounts: AsaasAccountOption[],
    currentAccount?: string | null
): AsaasAccountOption[] {
    const source = accounts.length > 0 ? accounts : FALLBACK_ASAAS_ACCOUNTS;

    return source.filter(
        (item) =>
            item.active ||
            item.account === currentAccount ||
            item.account === "default"
    );
}
